/**
 * An empty state is one line of direction, never a mood: what this screen holds,
 * and the one thing to do next. The mark stands in for an illustration.
 */
import type { ReactNode } from 'react';
import { Mark } from './Brand';

export function EmptyState({
  title,
  line,
  action,
  mark = true,
}: {
  title: string;
  line?: string;
  action?: ReactNode;
  mark?: boolean;
}) {
  return (
    <div className="ae-empty">
      {mark ? <Mark size={48} /> : null}
      <p className="ae-empty-title">{title}</p>
      {line ? <p className="ae-empty-line">{line}</p> : null}
      {action}
    </div>
  );
}
